import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import HeroSection from '../components/HeroSection';
import ServicesSection from '../components/ServicesSection';
import MapSection from '../components/MapSection';
import ExcursionsSection from '../components/ExcursionsSection';
import FleetSection from '../components/FleetSection';
import TestimonialsSection from '../components/TestimonialsSection';
import ReservationForm from '../components/ReservationForm';
import WhatsAppButton from '../components/WhatsAppButton';

const Home = () => {
  return (
    <div className="bg-[#0a0a0a] min-h-screen">
      <Header />
      <HeroSection />
      <ServicesSection />
      <MapSection />
      <ExcursionsSection />
      <FleetSection />
      <TestimonialsSection />
      <ReservationForm />
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default Home;
